import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Component({
  selector: 'app-data-filters',
  templateUrl: './data-filters.component.html',
  styleUrls: ['./data-filters.component.scss']
})
export class DataFiltersComponent implements OnInit {

  private HelperPosition = HELPER_POSITION;

  @Input() titleKey = null;
  @Input() hidden = false;
  @Input() showTitle = true;
  @Input() size: number;
  @Input() opened = false;
  @Input() fullWidth = false;
  @Input() noMarginBottom = false;
  @Input() disableSearch = false;
  @Input() helper = false;
  @Input() helperKey = null;
  @Input() helperColor = null;
  @Input() helperSide = this.HelperPosition.CENTER;

  @Output() openedChange: EventEmitter<any> = new EventEmitter<any>();

  private resetEmitter: Subject<void> = new Subject<void>();
  private resetObservable: Observable<void> = this.resetEmitter.asObservable();

  private applyEmitter: Subject<void> = new Subject<void>();
  private applyObservable: Observable<void> = this.applyEmitter.asObservable();

  public ngOnInit(): void {}

  public showFilters(): void {
    this.opened = !this.opened;
    this.openedChange.emit(this.opened);
  }

  public reset(): void {
    this.resetEmitter.next();
  }

  public apply(): void {
    this.applyEmitter.next();
  }

  public getResetObservable(): Observable<void>  {
    return this.resetObservable;
  }

  public getApplyObservable(): Observable<void> {
    return this.applyObservable;
  }
}

export enum HELPER_POSITION {
  RIGHT = 'RIGHT',
  LEFT = 'LEFT',
  CENTER = 'CENTER'
}
